import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { DropDownComp } from "./components/DropDown";
import { httpService } from "../../../base/services/httpService.service";
import { LocalStorageService } from "../../../base/services/local-storage.service";
import AuthService from "../../../base/services/authentication.service";
import { notification } from "antd";
import BasicModal from "../../../ui/BasicModal/BasicModal";
import ReactivatedModal from "../../workspace/components/ReactivatedModal/ReactivatedModal";
import AddPaymentMethodModal from "../../workspace/components/AddPaymentMethodModal/AddPaymentMethodModal";
import WorkspaceSelection from "../../workspace/components/workspaceSelection/WorkspaceSelection";
import { EntityTypeEnum } from "../../../utils/enums";
import https from "../../../base/utils/http";
import { withErrorBoundary } from "../../../components/ErrorBoundary/withErrorBoundary";
import ArchivedItemsModal from "../../../components/Archive/ArchivedItemsModal";
import { archiveWithNotice, isArchiveEnabled } from "../../../components/Archive/archiveApi";

import "./style.scss";

function AdminWorkspace() {
   const userDetails = JSON.parse(localStorage.getItem("roles"));
   const [isLoading, setIsLoading] = useState(false);
   const [workSpaces, setWorkSpaces] = useState([]);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [isArchivedOpen, setIsArchivedOpen] = useState(false);
   const [api, contextHolder] = notification.useNotification();

   const navigate = useNavigate();

   const openNotificationWithIcon = (type, description) => {
      if (type === "success") {
         api[type]({
            message: "Successfully",
            description: "Workspace Added Successfully"
         });
      } else {
         api[type]({
            message: "Error",
            description
         });
      }
   };

   const loadWorkspaces = useCallback(() => {
      setIsLoading(true);
      httpService.get("/Workspaces/getMyWorkspaces", (res) => {
         setWorkSpaces(res.data);
         setIsLoading(false);
      });
   }, []);

   useEffect(() => {
      loadWorkspaces();
   }, [loadWorkspaces]);

   const archiveWorkspace = async (id) => {
      if (await archiveWithNotice(EntityTypeEnum.Workspace, id)) loadWorkspaces();
   };
   const canArchive = isArchiveEnabled();

   const handleDelete = async (id) => {
      try {
         const params = new URLSearchParams({
            entityType: EntityTypeEnum.Workspace,
            isDeleted: true
         });
         const res = await https.put(
            `/DataCollection/${id}/toggleDeleteOrRestore?${params.toString()}`
         );

         notification.open({
            type: res.data.isSuccess ? "success" : "error",
            message: res.data.message || "Something went wrong! Please try again later."
         });
         if (res.data.isSuccess) {
            setWorkSpaces((prevWorkSpaces) =>
               prevWorkSpaces.filter((workspace) => workspace.id !== id)
            );
         }
      } catch (error) {
         if (
            error.response.status === 400 &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.includes &&
            error.response.data.errors.includes(
               "One or more of the projects in this workspace have surveys and can't be deleted!"
            )
         ) {
            setIsModalOpen(true);
         } else {
            openNotificationWithIcon("error", "Something went wrong. Please try again.");
         }

         notification.error({ message: "Error deleting workspace, please try again later." });
      }
   };

   const enterWorkspace = (workspaceId) => {
      LocalStorageService.setItem("currentWorkspaceId", workspaceId);
      LocalStorageService.removeItem("currentProjectID");
      navigate("/project-selection");
   };

   useEffect(() => {
      LocalStorageService.removeItem("currentWorkspaceId");
      LocalStorageService.removeItem("currentProjectID");
      navigate("/admin-workspaces");
   }, [navigate]);

   return (
      <>
         {contextHolder}
         <WorkspaceSelection
            userName={AuthService.getUser()?.fullName}
            roleLabel={userDetails?.[0]?.name?.replace(/([a-z])([A-Z])/g, "$1 $2")}
            workspaces={workSpaces || []}
            isLoading={isLoading}
            onEnterWorkspace={enterWorkspace}
            canCreateWorkspace
            onWorkspaceSaved={loadWorkspaces}
            onShowArchived={canArchive ? () => setIsArchivedOpen(true) : undefined}
            renderWorkspaceActions={(workspace, { onEdit }) => (
               <DropDownComp
                  handleDelete={handleDelete}
                  id={workspace.id}
                  onEdit={onEdit}
                  onArchive={canArchive ? archiveWorkspace : undefined}
               />
            )}
         />
         {canArchive && (
            <ArchivedItemsModal
               entityType={EntityTypeEnum.Workspace}
               isModalOpen={isArchivedOpen}
               onClose={() => setIsArchivedOpen(false)}
               onRestored={loadWorkspaces}
            />
         )}

         <BasicModal isModalOpen={isModalOpen} handleCancel={() => setIsModalOpen(false)}>
            <h3
               style={{
                  textAlign: "center"
               }}
            >
               One or more of the projects in this workspace have surveys and can't be deleted!
            </h3>
         </BasicModal>
         <ReactivatedModal />
         <AddPaymentMethodModal />
      </>
   );
}

export default withErrorBoundary(AdminWorkspace);
